export const EMAIL_STATUS_ERROR = 'error';
export const EMAIL_STATUS_PROCESSED = 'processed';
export const EMAIL_STATUS_DROPPED = 'dropped';
export const EMAIL_STATUS_DEFERRED = 'deferred';
export const EMAIL_STATUS_BOUNCE = 'bounce';
export const EMAIL_STATUS_SPAM = 'spam report';
export const EMAIL_STATUS_DELIVERIED = 'delivered';
export const EMAIL_STATUS_OPEN = 'open';
export const EMAIL_STATUS_CLICK = 'click';